import React from 'react'
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import i18n from '~/i18n';

export default class failedPaymentConfirm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            paymentCards: []
        };
        this.changeCard = this.changeCard.bind(this);
    }

    componentDidMount() {
        this.getPaymentCards();
    }

    getPaymentCards() {
        axios.get('/accountMaster/paymentMethod/stripe').then(response => {

            this.setState({
                loaded: true,
                paymentCards: response.data.customer.sources.data,
            })
        }).catch(console.log)

    }

    changeCard(event) {
        var cardVal = event.target.value;
        if (cardVal == "ADDNEW") {
            this.props.addCard();
            return;
        }

        axios.put('/accountMaster/paymentMethod/stripe', {
            default_source: cardVal
        }).then(() => {
            this.props.reChard();
        }).catch(err => {
        })

    }
    render() {

        if (!this.state.loaded) return <LoadingIcons iconType="2" />

        var cardData = this.state.paymentCards.map(cd => {
            return { "label": i18n.t('company:payments.cardEnding', { brand: cd.brand, last4: cd.last4 }), "value": cd.id }
        });

        cardData.push({ "label": i18n.t('company:payments.addNewCard'), "value": "ADDNEW" })

        var err = i18n.t('company:payments.errorChargingCard');
        if (this.props.err) {
            err = this.props.err;
            if (err == "Cannot charge a customer that has no active card") {
                err = i18n.t('company:payments.noPaymentMethodsFound');
            }
        }

        return <div>
            <h4 className="mar-b25">{i18n.t('company:payments.failedPaymentTitle')}</h4>
            <div className="mar-b25">{i18n.t('company:payments.failedPaymentDesc')}</div>
            <div className="text-red mar-b25">{err}</div>
            {(this.state.paymentCards && this.state.paymentCards.length > 0) && <Select outerClassName="mar-b25" placeholder={i18n.t('company:payments.selectAnotherCard')} data={cardData} onChange={this.changeCard} />}
            {(!this.state.paymentCards || this.state.paymentCards.length <= 0) && <div className="mar-b25">
                <div className="mar-b15">{i18n.t('company:payments.addPaymentMethodPrompt')}</div>
                <Button text={i18n.t('company:payments.addPaymentMethod')} className="button-primary" onClick={() => { window.open("/cp/company/subscription", "_self") }} />

            </div>}
        </div>
    }

};

